export const BLOGS_CONSTS = {
    GET_BLOG: "GET_BLOG",
    GET_BLOG_BY_ID: "GET_BLOG_BY_ID",
    GET_BLOG_CATEGORY: "GET_BLOG_CATEGORY",
};
